import { render } from "./GameplayView.vue?vue&type=template&id=357db024"
const script = {}

import "./GameplayView.vue?vue&type=style&index=0&id=357db024&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__